class Toggler {
    constructor(el) {
        this.DOM = {el: el};
        this.DOM.observeable = this.DOM.el.dataset.togglerObserve;
        this.DOM.targets = Array.from(document.querySelectorAll(this.DOM.observeable));

        /* Scope can be document for event delegation or array of targets */
        this.scope = this.DOM.el.hasAttribute('data-toggler-delegate') ? document : this.DOM.targets;
        this.event = this.DOM.el.dataset.event || 'click';
        this.togglerClass = this.DOM.el.dataset.togglerClass || 'is-open';
        this.observerClass = this.DOM.el.dataset.observerClass || 'is-active';
        this.closeOnOutside = this.DOM.el.dataset.closeOnOutside || false;

        this.initEvents();
    }
    initEvents() {
        /* Check if scope is array of items or document */
        if (Array.isArray(this.scope)) {
            this.scope.forEach((scope) => scope.addEventListener(this.event, (event) => this.toggle(event)));
        } else {
            /* If document send 'delegated' event type */
            this.scope.addEventListener(this.event, (event) => this.toggle(event, 'delegated'));
        }

        document.addEventListener('keyup', (event) => this.toggle(event, undefined, 'close'));

        const closeMenuBtns = document.querySelectorAll('.btn--close-menu');
        if (closeMenuBtns) {
            closeMenuBtns.forEach((closeMenuBtn) => {
                closeMenuBtn.addEventListener('click', () => this.removeClasses());
            });
        }
    }

    toggle(event, eventType, action) {
        /* Check if delegated event type */
        const eventTarget = eventType === 'delegated' ? event.target : event.currentTarget;

        if (event.keyCode === 27 && action === 'close') {
            this.removeClasses();
            return;
        }

        if (!eventTarget || eventTarget === document) return;

        if (eventTarget.matches ? eventTarget.matches(this.DOM.observeable) : eventTarget.msMatchesSelector(this.DOM.observeable)) {
            event.preventDefault();

            let parent;
            if (eventTarget.dataset.toggleDropdownOne !== undefined) {
                parent = eventTarget.parentNode.parentNode.parentNode;
            } else {
                parent = eventTarget.parentNode.parentNode;
            }

            // Remove observerClass from nav-items elements
            // Remove togglerClass from nav__dropdown elements
            const directChildren = parent.children;
            for (let i = 0; i < directChildren.length; i++) {
                const child = directChildren[i];
                if (child !== eventTarget && child.classList.contains('nav-item')) {
                    const navLink = child.querySelector('.nav-link');
                    if (navLink && navLink !== eventTarget) {
                        navLink.classList.remove(this.observerClass);
                    }

                    const navDropDown = child.querySelector('.nav__dropdown');
                    if (navDropDown && navLink !== eventTarget) {
                        navDropDown.classList.remove(this.togglerClass);
                    }
                }
            }

            // Toggle the clicked submenu
            this.DOM.el.classList.toggle(this.togglerClass);
            eventTarget.classList.toggle(this.observerClass);
        }


        if (this.closeOnOutside && eventTarget !== this.DOM.el && eventTarget !== this.DOM.target) {
            this.removeClasses();
        }
    }
    removeClasses() {
        this.DOM.el.classList.remove(this.togglerClass);
        this.DOM.targets.forEach((target) => target.classList.remove(this.observerClass));
    }
}

const togglerNodes = Array.from(document.querySelectorAll('[data-toggler]'));
if (togglerNodes !== null) {
    togglerNodes.forEach((toggler) => { new Toggler(toggler); })
}
